import React, { Component } from 'react';
import { Container, Row, Col as Column } from 'react-grid-system';

class Footer extends Component {
  render() {
    const containerStyle = {
      background: '#111018',
      padding: '48px 0',
      width: '100%',
    };
    const topTextStyle = {
      fontSize: '0.7em',
      color: 'rgba(255,255,255,0.64)',
      margin: '4px 0',
    };
    const bottomTextStyle = {
      fontSize: '0.7em',
      color: 'rgba(255,255,255,1)',
      margin: '4px 0',
    };

    return (
      <div style={containerStyle}>
        <Container>
          <Row>
            <Column lg={3} md={4}>
              <p style={topTextStyle}>Barry Chusid</p>
              <p style={bottomTextStyle}>Please Contact Management</p>
            </Column>
            <Column lg={3} md={4}>
              <p style={topTextStyle}>United Talent Agency</p>
              <p style={bottomTextStyle}>Pete Franciosa  &  Mike Rubi</p>
              <p style={bottomTextStyle}>1-310-273-6700</p>
            </Column>
            <Column lg={3} md={4} push={{ lg: 3, md: 0 }}>
              <p style={topTextStyle}>Copyright {new Date().getFullYear()}, Barry Chusid</p>
            </Column>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./components/Footer/index.js